export const signupStyles = (theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    margin: 'auto',
  },
  leftWrapper: {
    backgroundColor: '#FFFFFF',
    maxWidth: '700px',
    boxShadow: '0px 5px 7px -1px rgba(0,0,0,0.25)',
    flex: 1,
  },
  rightWrapper: {
    width: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url("images/auth_bg.jpg")',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  panel: {
    margin: '20px 0',
    padding: '30px 60px',
    borderRadius: 4,
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
  loginWrapper: {
    textAlign: 'center',
  },
  loginLink: {
    textDecoration: 'none',
  },
  loginMessage: {
    color: theme.palette.primary.main,
    fontFamily: 'FSEmeric-Medium',
    marginLeft: 4,
    '&:hover': { textDecoration: 'underline' },
  },
})
